export const REF_ARRAY_DATA_TYPE = 'RefArray'
export const CLASSIC_LAYOUT_TYPE = 'ClassicLayout'

export const IS_LOCALHOST = LOCALHOST
export const CONVERTER_SOURCE = 'DmConverterSource'
export const LOCALHOST_VERSION = 'localhost'
